export const statics = [];
export const commons = [];